import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppfolioLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_45316_112653)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
			fill: "#007CCE"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M31.0753 17.7288C31.0753 16.9056 31.0496 16.1265 31.0496 15.4443C31.0496 11.1039 28.986 8.93364 27.254 7.8772C25.4874 6.88707 23.4905 6.38141 21.4656 6.41142C17.1727 6.41142 14.01 7.63053 12.0558 10.0296C10.9276 11.455 10.2475 13.183 10.1016 14.995C10.0971 15.0421 10.0971 15.0892 10.1016 15.1359C10.1547 15.7143 10.4227 16.2519 10.8527 16.6425C11.2805 17.0313 11.84 17.2432 12.418 17.2354C12.9639 17.2913 13.5101 17.1337 13.9425 16.7959C14.3768 16.456 14.6647 15.9629 14.7473 15.4176C15.2447 13.0843 16.3482 10.9234 21.0642 10.9234C23.5638 10.9234 25.1953 11.443 26.0504 12.5123C26.344 12.8325 26.5667 13.2112 26.7038 13.6234C26.8413 14.0364 26.8907 14.4737 26.8487 14.907C26.8487 15.6994 26.5518 16.6679 24.2309 17.1825C22.726 17.5132 21.1425 17.6981 19.6113 17.8741L18.8785 17.9621C10.1976 18.9963 8.88867 23.6185 8.88867 26.2772C8.88867 31.1016 14.6384 33.831 18.7909 33.963H19.5589C21.1304 33.9975 22.6932 33.7206 24.1571 33.1483L24.2833 33.0959C25.7214 32.5423 27.0224 31.6836 28.0967 30.579C29.1747 29.4704 30.0017 28.1429 30.5216 26.6865C31.198 24.851 31.1362 21.0652 31.0753 17.7288ZM26.6611 22.6368C26.6611 28.1656 21.3998 29.3759 19.3713 29.3759C16.6056 29.3759 13.626 27.8928 13.626 25.4892C13.626 22.9008 15.934 22.0865 20.7851 21.3381C22.0456 21.1448 24.1007 20.779 25.4611 20.515C25.8736 20.4283 26.2758 20.2985 26.6611 20.1279V22.6368Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_45316_112653",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "white"
		})
	}) })]
});
export default SvgAppfolioLogo;
